'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('interactiveSchemeCtrl', ["$scope", function ($scope) {
	$scope.list = interactiveschemeData.list;
//	console.log($scope.list);
}]);